import Pepperoni from "../assets/pepperoni.jpg";
import Margherita from "../assets/margherita.jpg";
import PedroTechSpecial from "../assets/pedrotechspecial.jpg";
import Vegan from "../assets/vegan.jpg";
import Pineapple from "../assets/pineapple.jpg";
import Expensive from "../assets/expensive.jpg";

export const MenuList= [
    {
        name: "Pepperoni Pizza",
        image: Pepperoni,
        price: 799,
      },

      {
        name: "Margherita Pizza",
        image: Margherita,
        price: 599,
      },

      {
        name: "PedroTech Special",
        image: PedroTechSpecial,
        price: 1299,
      },

      {
        name: "Vegan Pizza",
        image: Vegan,
        price: 899,
      },

      {
        name: "Pineapple Pizza",
        image: Pineapple,
        price: 449,
      },

      {
        name: "Very Expensive Pizza",
        image: Expensive,
        price: 4999,
      }
]